var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactUsHovered = function SvgContactUsHovered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.591 17.686-.277.416-3.295-2.197 3.572 1.781Zm0 0-.277.416a1.441 1.441 0 0 1 .221 2.219l-1.375 1.374a2.71 2.71 0 0 1-2.068.801h-.001c-1.647-.097-5.072-.813-8.922-4.664-3.853-3.852-4.567-7.277-4.664-8.923v-.001a2.704 2.704 0 0 1 .8-2.068l1.373-1.374v-.001a1.442 1.442 0 0 1 2.22.22l2.197 3.296c.38.569.304 1.335-.18 1.82l-.867.867-.177.177.036.247c.085.592.425 1.91 1.758 3.242 1.334 1.334 2.65 1.674 3.243 1.76l.247.035.177-.177.868-.866m5.391 1.6-5.39-1.6m0 0a1.447 1.447 0 0 1 1.818-.18l-1.819.18Zm-.635-6.256.07-.21-.108-.193a5.305 5.305 0 0 1-.68-2.601A5.332 5.332 0 0 1 17.174 1.5 5.332 5.332 0 0 1 22.5 6.826a5.332 5.332 0 0 1-5.326 5.326 5.299 5.299 0 0 1-2.6-.678l-.193-.109-.21.07-2.129.71h-.003a.146.146 0 0 1-.147-.035v-.001a.149.149 0 0 1-.037-.151l.71-2.128Zm.871-3.004a1.147 1.147 0 1 0 2.295 0 1.147 1.147 0 0 0-2.295 0Zm2.59 0a1.147 1.147 0 1 0 2.294 0 1.147 1.147 0 0 0-2.294 0Zm2.589 0a1.147 1.147 0 1 0 2.295 0 1.147 1.147 0 0 0-2.295 0Z",
    fill: "#fff",
    stroke: "#069BAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6.5,
    r: 4.5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8h1.4m-1.4-3H19",
    stroke: "#069BAA",
    strokeLinecap: "round"
  })));
};
export default SvgContactUsHovered;